import { ControlConfig } from '../controlConfig';
import AddControlTime from './AddControlTime';
import ControlTimeEngine from './ControlTimeEngine';
import ControlTimeEntry from './ControlTimeEntry';
import ControlTimePlaceholder from './ControlTimePlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForTimeEngine from './getYupSchemaForTimeEngine';
import getYupSchemaForTimeEntry from './getYupSchemaForTimeEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlTimeEngine,
  Entry: ControlTimeEntry,
  Add: AddControlTime,
  yupSchemaEngine: getYupSchemaForTimeEngine,
  yupSchemaEntry: getYupSchemaForTimeEntry,
  translator,
  Placeholder: ControlTimePlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
